import React from 'react';
import { withModelInfo } from '../common/ModelInfoContext';

class CookiesNotifications extends React.Component {
  componentDidMount() {
    const { adChoicesCookiesUrl: url, adChoicesId: id } = this.props.modelInfo;

    if (url) {
      let scriptElement = document.createElement('script');
      scriptElement.src = url;
      scriptElement.setAttribute('type', 'text/javascript');
      scriptElement.setAttribute('data-ev-hover-pid', id);
      scriptElement.setAttribute('data-ev-hover-ocid', '797');
      document.body.appendChild(scriptElement);
    }
  }

  render() {
    return null;
  }
}

export default withModelInfo(CookiesNotifications);
